export default __webpack_public_path__ + "static/media/sun.17bb5111.jpg";